import {
  AccordionButton as ChakraAccordionButton,
  useAccordionItemState,
  useAccordionStyles,
} from '@chakra-ui/react-v2';
import type { AccordionButtonProps as ChakraAccordionButtonProps } from '@chakra-ui/react-v2';
import type { Merge } from 'type-fest';

import { type IconProps } from '@frontend/legacy-components';
import { ChevronDownIcon } from '@frontend/legacy-components/src/components/mediaAndIcons/icons/iconSet';

export type AccordionButtonProps = Merge<
  ChakraAccordionButtonProps,
  { iconProps?: IconProps }
>;

export const AccordionButton = ({
  children,
  iconProps,
  ...props
}: AccordionButtonProps) => {
  const { isOpen } = useAccordionItemState();
  const { icon: iconStyles } = useAccordionStyles();

  const { sx: iconPropsSx, ...restIconProps } = iconProps ?? {};

  const iconSx = {
    transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
    ...iconPropsSx,
  };

  return (
    <ChakraAccordionButton {...props}>
      <ChevronDownIcon __css={iconStyles} sx={iconSx} {...restIconProps} />
      {children}
    </ChakraAccordionButton>
  );
};
